export default __webpack_public_path__ + "static/inclusive-400-cc4c646748f02056b713122ff19b5dcb.webp";